<template>
  <v-container fluid>
    <div class="modal-padding myt-modal">
      <div class="billing-details-title">Billing Details
      <div class="close-outer float-right top-zero" @click="onClose({ status: false })">
          <img src="../../../assets/img/close-icon.svg" class="close-icon" />
        </div>
      </div>
      <div class="popup-scroll">
      <v-row>
        <v-col cols="12" sm="12" class="zero-top">
          <div class="myt-input-outer">
            <v-text-field
              label="Billing Name"
              dense
              outlined
              hide-details
              v-model="billing_name"
            ></v-text-field>
            <InputError v-if="error && error.billing_name.message" :data="error.billing_name" />

          </div>
          <div class="myt-input-outer">
            <v-text-field
              label="Billing Address"
              dense
              outlined
              hide-details
              v-model="billing_address"
            ></v-text-field>
            <InputError v-if="error && error.billing_address.message" :data="error.billing_address" />
          </div>
          <div class="myt-dropdown add-ch-arrow">
            <div class="practice-session-drop-down">
              <div class="field-data myt-input-outer">
                <v-select
                  v-model="selectedState"
                  :items="states"
                  label="State"
                  hide-details
                  dense
                  outlined
                  class="select-state"
                ></v-select>
                <InputError v-if="error && error.selectedState.message" :data="error.selectedState" />
              </div>
            </div>
          </div>
          <div class="myt-input-outer">
            <v-text-field
              label="GSTIN(If Applicable)"
              dense
              outlined
              hide-details
              v-model="gstnin"
            ></v-text-field>
            <InputError v-if="error && error.gstnin.message" :data="error.gstnin" />
          </div>
        </v-col>
      </v-row>
      <div class="billing-order-title">Your Order Details</div>
      <div class="test-mock">
        <span class="tast-name-order">Test Name: </span>
        <span class="tast-name-mock">{{ data.test_name }}</span>
      </div>
      <div class="billing-row-myt">
        <div class="billing-col-myt">Net Amount</div>
        <div class="billing-col-myt-bold">₹ {{ priceDetails?priceDetails.total_product_amount:""}}</div>
      </div>
      <div class="billing-row-myt">
        <div class="billing-col-myt">GST @18%</div>
        <div class="billing-col-myt-bold">₹ {{ priceDetails ?priceDetails.gst_amount:"" }}</div>
      </div>
      <div class="billing-row-myt">
        <div class="billing-col-myt">Round Off</div>
        <div class="billing-col-myt-bold">00.00</div>
      </div>
      <div class="billing-row-myt">
        <div class="billing-col-my-large">Total Payable Amount</div>
        <div class="billing-col-myt-bold-large">₹ {{ priceDetails?priceDetails.total_amount_with_gst:"" }}</div>
      </div>
      <div class="check-cust check-myt">
        <v-checkbox v-model="isAgreed"></v-checkbox>
        <div class="agree-text" @click="onClose({ status: true, showTermsAndConditions: true, gstnin:gstnin,selectedState:selectedState,billing_name:billing_name,billing_address:billing_address, ...data })">
          I agree with the <a herf="">Terms and Conditions</a>
        </div>
      </div>
      <InputError v-if="error && error.isAgreed.message" :data="error.isAgreed" />
      <div class="emailed-text">
        The invoice shall be e-mailed to your registered e-mail address on the 2nd of the coming month. 
        In case you have any query, please drop an email to <a class="italics-styling"  href="mailto: hello@eduracle.com"> hello@eduracle.com</a>
      </div>
      <div class="left-align pay-now-btn">
        <v-btn class="right-btn cust-btn" color="primary" @click="createOrder">Pay Now</v-btn>
      </div>
    </div>
    <PaymentHiddenInput :order="order" />
    </div>
  </v-container>
</template>
<script>
import CommonInstructionsContent from "@/components/student/Tests/CommonInstructionsContent.vue";
import { Country, State, City }  from 'country-state-city';
import { mapActions, mapState } from "vuex";
import PaymentHiddenInput from "../../coordinator/subscription-details/PaymentHiddenInput.vue";

export default {
  components: {
    CommonInstructionsContent,
    PaymentHiddenInput
  },
  name: "InstructionsPopup",
  props: ["onClose", "status", "data"],
  data() {
    return {
      states:[],
      selectedState:null,
      priceDetails:null,
      billing_address:"",
      billing_name:"",
      gstnin:"",
      isAgreed:false,
      error:{
        billing_address:{
          type:null,
          message:""
        },

        billing_name:{
          type:null,
          message:""
        },

        selectedState:{
          type:null,
          message:""
        },
        gstnin:{
          type:null,
          message:""
        },
        isAgreed:{
          type:null,
          message:""
        },
        
      },
      order:null
    }
  },
  mounted() {
    if (this.data) {
      this.billing_name = this.data.billing_name ? this.data.billing_name : '';
      this.billing_address = this.data.billing_address ? this.data.billing_address : '';
      this.selectedState = this.data.selectedState ? this.data.selectedState : '';
      this.gstnin = this.data.gstnin ? this.data.gstnin : '';
    }
    this.renderMath();
    this.states=State.getStatesOfCountry('IN').map(s=>{
      s.text = s.name;
      s.value=s.name;
      return s;
    })
    if (this.data && this.data.id) {
      this.getPriceDetails();
    }
    this.getBillingDetails();
  },
  methods:{
    ...mapActions({
      getPriceDetailsMyt: "utilStore/getPriceDetailsMyt",
      createPackageOrder: "userStore/createPackageOrder",
      updateTransactionStatus: "userStore/updateTransactionStatus",
      getBillingDetailsMYT: "utilStore/getBillingDetailsMYT",
    }),
    getPriceDetails(){
      let reqData = {
        test_id:this.data.id,
        product_ids:[23],
        billing_details_required: true,
        user_id:this.user?this.user.id.toString():localStorage.getItem('guest_user_id')
      }

      this.getPriceDetailsMyt(reqData)
      .then(response=>{
        this.priceDetails = response;
        this.$forceUpdate()
      }).catch(err=>{
        console.error(err);
      })
    },
    createOrder(){
      if (this.handleValidaton()) {
        let success_redirect = window.location.href.split("?")[0];
        let failure_redirect = success_redirect;
        let reqData ={
          product_ids: [
              23
          ],
          test_id: this.data.id,
          success_redirect,
          failure_redirect,
          coupon: "",
          gst_number: this.gstnin,
      
          billing_details: {
            name :this.billing_name,
            address:this.billing_address,
            state:this.selectedState,
            gst_number :this.gstnin,
          }
          
        }
        this.createPackageOrder(reqData)
        .then(response=>{
          this.generateDataForPayment(response.order)
        })
        .catch(err=>{
          console.log(err);
        })
      }
    },
    generateDataForPayment(order) {
      this.orderId = order.tx_id;
      let phoneNumber = this.user.phone;
      //phoneNumber = phoneNumber[1];
      let pd = {
        key: order.key,
        txnid: order.tx_id + "",
        amount: order.amount,
        firstname: this.user.name,
        email: this.user.email,
        phone: phoneNumber,
        productinfo: "" + order.productsForPurchase,
        surl: order.surl,
        furl: order.furl,
        hash: order.hash,
        mode: "dropout",
        udf1: order.udf1,
        udf2: order.udf2,
        udf3: order.udf3,
        udf5: "",
        pg_url: order.pg_url
      };
      this.order =pd
      // this.launchBOLT(pd);
    },
    launchBOLT(pd) {
      let that = this;
      let handler = {
        responseHandler: function(BOLT) {
          that.checkTransactionStatus(BOLT);
        },
        catchException: function(BOLT) {
          that.handleBoltError(BOLT);
        }
      };

      bolt.launch(pd, handler);
    },
    handleBoltError(BOLT) {
      this.$toasted.error(BOLT.message);
    },
    checkTransactionStatus(BOLT) {
      if (BOLT.response.txnStatus == "CANCEL") {
        let postData = {
          order_id: this.orderId
        };
        this.updateTransactionStatus(postData)
          .then((response) => {
            // this.getPackagesList();
            this.isAgreed = false;
            this.$toasted.success("Transaction Cancelled by User.");
          })
          .catch((err) => {
            this.$toasted.error("Error while updating transaction status.");
          });
      }
    },
    handleValidaton(){
      let valid = true
      this.error.billing_address.type = null
      this.error.billing_name.type = null
      this.error.gstnin.type = null
      this.error.selectedState.type = null
      this.error.isAgreed.type = null

      if (!this.billing_name) {
       this.error.billing_name.type = 'error'
       this.error.billing_name.message = 'Please Enter Billing Name'
        valid=false
      }
      if (!this.billing_address) {
       this.error.billing_address.type = 'error'
       this.error.billing_address.message = 'Please Enter Billing address'
        valid=false
      }
      if (!this.selectedState) {
       this.error.selectedState.type = 'error'
       this.error.selectedState.message = 'Please Select State'
        valid=false
      }
      if (this.gstnin &&
        this.gstnin.length &&
        !this.isValidGST(this.gstnin)) {
       this.error.gstnin.type = 'error'
       this.error.gstnin.message = 'Please Enter valid GST Number'
        valid=false
      }
      if (!this.isAgreed) {
       this.error.isAgreed.type = 'error'
       this.error.isAgreed.message = 'Please accept Terms & conditions'
        valid=false
      }
      return valid
    },
    isValidGST(num) {
      let regex = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}" + "[A-Z]{1}[1-9A-Z]{1}" + "Z[0-9A-Z]{1}$"
      );
      if (regex.test(num)) {
        return true;
      }
      return false;
    },
    getBillingDetails(){
      let reqData = {
        user_id:this.user.id
      }
      this.getBillingDetailsMYT(reqData)
      .then((response) => {
        this.billing_address = response.billing_address;
        this.billing_name = response.billing_name;
        this.selectedState = response.billing_state;
        this.gstnin = response.billing_gst_number ? response.billing_gst_number : ''
      })
      .catch((error) => {
        console.log(error);
      })
    }
  },
  computed:{
    ...mapState("userStore", ["user"]),

  },
  watch: {
    status(val) {
      if (val) {
        this.isTwoColumn = 2;
        this.isRoughWork = false;
        this.selectedDownloadOption = 1;
        if(this.data && this.data.id){
          this.getPriceDetails();
          this.getBillingDetails();
        }
      }
    }
  }
};
</script>
